import React, { useState, useEffect } from 'react'
import db from '../firebase/config'
import { Container, Col, Row } from 'reactstrap'

const Main = () => {

    const [about, setAbout] = useState([]);

    useEffect(() => {
        db.collection("about").onSnapshot((snapshot) =>
            setAbout(snapshot.docs.map((doc) => doc.data())))
    }, [])

    return (
        <>
            <div className="aboutInfo">
                {about.map((abouts => (
                    <>
                        <Container>
                            <Row>
                                <Col md="12">
                                    <img
                                        src={abouts.image}
                                        alt="about images"
                                        className="myImage"
                                    />
                                    <span>
                                        <p className="aboutText">
                                            {abouts.text1}
                                            <div>
                                                <b>{abouts.text3}</b>
                                            </div>
                                        </p>
                                    <ul>
                                        <li>✅ React and Redux, Redux-Saga, Context API, Hooks</li>
                                        <li>✅ HTML/CSS</li>
                                        <li>✅ JavaScript, HTML5, CSS3, jQuery</li>
                                        <li>✅ Bootstrap 3/4/5, Tailwind CSS, SASS</li>
                                        <li>✅ Bootstrap template</li>
                                        <li>✅ Pixel Perfect Design</li>
                                        <li>✅ Responsive Design</li>
                                        <li>✅ Restful API, Axios, Postman</li>
                                        <li>✅ Figma, Adobe XD</li>
                                        <li>✅ Trello, Jira</li>
                                        <li>✅ Git, Github</li>
                                        <li>✅ Firebase, Vercel, AWS, Netlify</li>
                                    </ul>
                                    </span>

                                </Col>
                            </Row>
                        </Container>

                    </>
                )))}
            </div>
        </>
    )
}

export default Main
